// profile/getters.ts
import { state } from './index';
import { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '../types';
import { GetterTree } from 'vuex';
import { ProfileState, User, OrgData, ProfileData } from './types';

export const getters: GetterTree<ProfileState, RootState> = {
    orgGetter: (curState): OrgData => {
        const { user } = curState;
        const gottenOrgData = user!.orgData;
        return gottenOrgData;
    },

    profileGetter: (curState): ProfileData => {
        const { user } = curState;
        const gottenProfileData = user!.profileData;
        return gottenProfileData;
    },
};
